module.exports = __webpack_public_path__ + "img/sti-dest_dg_woodpacking.ba737924.svg";